import { useGetBlogsQuery } from '@apis/mediacore/blog'
import { makeItemsNav } from '@helpers/helper.rendering'
import useQuerySummary from '@hooks/useQuerySummary'
import { Link } from 'gatsby'
import React, { Fragment, useEffect, useState } from 'react'
import { Col, Container, Nav, Navbar, Row } from 'react-bootstrap'
import { RealEstateDataHeaderData, RealEstateDataPage, StateUserSlice } from 'types'
import { useLocation } from '@reach/router'
import { useGetJobsQuery } from '@apis/mediacore/jobs'
import ReCAPTCHA from 'react-google-recaptcha'
import { useGetSummarySiteQuery } from '@apis/mediacore/core'
import DatePicker from 'react-date-picker'
import 'react-date-picker/dist/DatePicker.css'
import 'react-calendar/dist/Calendar.css'
import { useDispatch, useSelector } from 'react-redux'
import { updateHeader11 } from '@slices/userSlice'
import $ from 'jquery'
import { makeJsonContact } from '@helpers/helper.contact'
import { useCreateFormMutation as useSendContactFormMutationMediacore } from '@apis/mediacore/contact'
import toast from 'react-hot-toast'

interface ExternalProps {
  pages: RealEstateDataPage[]
  development_id: string
  property_id: string
  novelty_id: string
}

type CombinedProps = RealEstateDataHeaderData & ExternalProps

const Header11 = (props: CombinedProps) => {
  const { global_data, pages, height, logoSize, fontColor, spanText, hoverColor } = props

  const { id: siteId } = global_data
  const API_KEY = global_data.pageConfig.keys.tokko
  const [disabled, setDisabled] = useState(true)
  const [token, setValueToken] = useState('')

  const { data: allSiteData } = useGetSummarySiteQuery(
    process.env.GATSBY_IS_SITE_COMPILER == 'true' ? siteId : process.env.GATSBY_TENANTID,
  )
  const INVESTOR_CONFIGURATION = allSiteData?.custom_login?.find(
    (config: { module: string }) => config.module === 'INVESTOR',
  )
  const OWNER_CONFIGURATION = allSiteData?.custom_login?.find(
    (config: { module: string }) => config.module === 'OWNER',
  )
  const hasModules = (INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module)?.length > 0

  const social = global_data.pageConfig.social
  const icons: string = global_data.pageConfig.design.icons
  const iconsStyle = icons === 'Solid' || icons === 'Light' ? `-${icons.toLowerCase()}` : ''

  const { data: allBlogData } = useGetBlogsQuery({ site: siteId })
  const { allSummaryData } = useQuerySummary({ API_KEY })
  const { data: allJobsData } = useGetJobsQuery({ site: siteId })

  const logo = global_data.logo
  const logoMobile = global_data.logoMobile

  const [isMounted, setIsMounted] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)

  const handleMenuToggle = () => {
    setMenuOpen(!menuOpen)
  }

  const location = useLocation()

  function onChange(value: any) {
    setValueToken(value)
  }

  useEffect(() => {
    setIsMounted(true)
    document.documentElement.style.setProperty('--spanText-value', spanText || '#fff')
    document.documentElement.style.setProperty('--fontColor-value', fontColor || '#fff')
    document.documentElement.style.setProperty(
      '--navbar-height',
      height?.desktop
        ? screen.width < 992
          ? height.mobile + (height.scalePixels ? 'px' : 'vh')
          : height.desktop + (height.scalePixels ? 'px' : 'vh')
        : '120px',
    )
    if (!captcha) {
      setDisabled(false)
    } else {
      setDisabled(true)
    }
  }, [])

  const itemsNav = makeItemsNav(allSummaryData, allBlogData, pages, allJobsData).filter(
    (page) => !page.path.includes('detalle'),
  )

  const captcha = global_data.pageConfig.keys.captcha

  const [dataForm, setDataForm] = useState({
    name: '',
    phone: '',
    email: '',
    message: '',
    daily: 'Mañana',
    calendar: new Date(),
  })

  // const [view, setView] = useState(0)

  const dispatch = useDispatch()

  const handleInputChange = (event: any) => {
    setDataForm({
      ...dataForm,
      [event.target.name]: event.target.value,
    })
  }

  const {
    header11: { open, view },
  } = useSelector((state: { user: StateUserSlice }) => state.user)!

  const divisionPath = global_data.divisionPath
  const [sendContactFormMediacore] = useSendContactFormMutationMediacore()

  useEffect(() => {
    if (open) {
      $('body').addClass('overflow-hidden')
    } else {
      $('body').removeClass('overflow-hidden')
    }
  }, [open])

  const sendForm = (event: any) => {
    event.preventDefault()
    var tags = ['Sitio Web', 'Contacto encabezado']
    if (process.env.GATSBY_IS_SITE_COMPILER === 'true') {
      tags.push(divisionPath!.replaceAll('/', ''))
    }

    sendContactFormMediacore({
      data: {
        ...dataForm,
        callphone: dataForm.phone,
        text:
          dataForm.message +
          (view == 1
            ? ' \n Fecha de visita: ' +
              dataForm.calendar.toLocaleDateString('es-AR') +
              ' A la ' +
              dataForm.daily
            : ''),
        tags: tags,
        url: location.href,
        token: token,
      },
      type: 'contact',
      site: global_data.id,
    })
    ;(document?.getElementById('formHeader11') as HTMLFormElement).reset()
    return toast.success('¡Mensaje enviado correctamente!')
  }

  function setDateInData(value: any) {
    setDataForm({ ...dataForm, calendar: value })
    return value
  }

  function hexToRgba(hex: string, opacityString: string) {
    // Elimina el símbolo '#' si está presente
    hex = hex.replace(/^#/, '')

    // Convierte el string en número y lo transforma a rango 0-1
    let alpha = parseInt(opacityString, 10) / 100

    // Soporte para hex corto (ej: #FAB → #FFAABB)
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((char) => char + char)
        .join('')
    }

    // Extrae valores R, G, B
    const r = parseInt(hex.substring(0, 2), 16)
    const g = parseInt(hex.substring(2, 4), 16)
    const b = parseInt(hex.substring(4, 6), 16)

    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  }

  return isMounted ? (
    <header
      id="header"
      className="header header-11"
      style={{ background: hexToRgba(spanText || '#fff', hoverColor || '100') }}
    >
      <div className={'contactOopen-section ' + (open ? 'open' : '')}>
        <div
          className={
            'top-header-content d-flex align-items-center justify-content-center ' +
            (open ? ' open ' : '')
          }
          style={{
            background: spanText,
            width: '70%',
            position: 'absolute',
            height: height?.desktop + (height?.scalePixels ? 'px' : 'vh'),
          }}
        >
          <div className="d-flex justify-content-center align-items-center px-xl-5">
            <Link
              aria-label="Enlace inicio"
              className="d-flex align-items-center m-0"
              to="/"
            >
              <img
                alt="logo-header"
                src={logo}
                height={
                  logoSize && height?.desktop
                    ? screen.width < 992
                      ? (parseInt(height?.mobile) * parseInt(logoSize)) / 100 + 'px'
                      : (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                    : '45px'
                }
                width={'auto'}
                className="d-lg-inline-block d-none align-top logo-header"
              />
            </Link>
          </div>
        </div>
        <div
          style={{ background: spanText }}
          className="contact-form-section"
        >
          <button
            className="x"
            onClick={() => dispatch(updateHeader11({ open: false, view: 0 }))}
          ></button>
          <div className="p-4">
            <h2 style={{ color: fontColor || '#fff' }}>HABLEMOS</h2>
            <p style={{ color: fontColor || '#fff' }}>
              No hace falta que tengas todo resuelto. A veces, una conversación es el mejor
              comienzo.
            </p>
            <div
              style={{ color: fontColor || '#fff' }}
              className="form-double"
            >
              <button
                onClick={() => dispatch(updateHeader11({ open: true, view: 0 }))}
                style={{ background: spanText, color: fontColor || '#fff' }}
                className={'select-view ' + (view === 0 ? 'active' : '')}
              >
                CONTACTAR
              </button>
              <button
                onClick={() => dispatch(updateHeader11({ open: true, view: 1 }))}
                style={{ background: spanText, color: fontColor || '#fff' }}
                className={'select-view ' + (view === 1 ? 'active' : '')}
              >
                SOLICITAR VISITA
              </button>
              {
                <form
                  onSubmit={sendForm}
                  className="px-3 d-flex flex-wrap justify-content-between"
                  method="post"
                  id="formHeader11"
                >
                  {view == 1 && (
                    <div
                      className="d-block w-100"
                      style={{ zIndex: 99 }}
                    >
                      <div className="d-flex w-100">
                        <DatePicker
                          className={'w-100'}
                          locale="es-AR"
                          format="dd-MM-yyyy"
                          // onChange={(value) => setDataForm({...dataForm,calendar:value})}
                          value={dataForm.calendar}
                          onChange={(date) => setDateInData(date)}
                        />
                      </div>
                      <div
                        className="d-flex w-100"
                        style={{ zIndex: 99 }}
                      >
                        <div
                          className={
                            'checkbox-content ' + (dataForm.daily == 'Mañana' ? 'active' : '')
                          }
                          onClick={() => setDataForm({ ...dataForm, daily: 'Mañana' })}
                        >
                          Mañana
                        </div>
                        <div
                          className={
                            'checkbox-content ' + (dataForm.daily == 'Tarde' ? 'active' : '')
                          }
                          onClick={() => setDataForm({ ...dataForm, daily: 'Tarde' })}
                        >
                          Tarde
                        </div>
                      </div>
                    </div>
                  )}
                  <input
                    type="text"
                    onChange={handleInputChange}
                    name="name"
                    placeholder="Nombre y Apellido"
                    className="half"
                    style={{ background: spanText, color: fontColor || '#fff' }}
                  />
                  <input
                    type="text"
                    onChange={handleInputChange}
                    name="phone"
                    placeholder="Teléfono"
                    className="half"
                    style={{ background: spanText, color: fontColor || '#fff' }}
                  />
                  <input
                    type="text"
                    onChange={handleInputChange}
                    name="email"
                    className="w-100"
                    required
                    placeholder="Email *"
                    style={{ background: spanText, color: fontColor || '#fff' }}
                  />
                  <textarea
                    name="message"
                    onChange={handleInputChange}
                    rows={3}
                    placeholder="Mensaje"
                    className="w-100"
                    style={{ background: spanText, color: fontColor || '#fff' }}
                  />
                  {captcha ? (
                    <ReCAPTCHA
                      sitekey={captcha}
                      onChange={(value) => {
                        setDisabled(false)
                        onChange(value)
                      }}
                    />
                  ) : (
                    ''
                  )}
                  <input
                    className="submit-button btn-white border mt-4 btn"
                    disabled={disabled}
                    type="submit"
                    value="Enviar"
                  />
                </form>
              }
            </div>
            <h5
              className="mt-lg-5 mb-lg-3"
              style={{ color: fontColor || '#fff' }}
            >
              Seguime en redes
            </h5>
            <div className="d-flex- redes">
              {social?.instagram && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social instagram"
                  href={social?.instagram}
                  className={social?.instagram ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-instagram${iconsStyle}`}
                  ></i>
                </a>
              )}
              {social?.facebook && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social facebook"
                  href={social?.facebook}
                  className={social?.facebook ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-facebook${iconsStyle}`}
                  ></i>
                </a>
              )}
              {social?.linkedin && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social linkedin"
                  href={social?.linkedin}
                  className={social?.linkedin ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-linkedin${iconsStyle}`}
                  ></i>
                </a>
              )}
              {social?.youtube && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social youtube"
                  href={social?.youtube}
                  className={social?.youtube ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-youtube${iconsStyle}`}
                  ></i>
                </a>
              )}
              {social?.twitter && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social twitter"
                  href={social?.twitter}
                  className={social?.twitter ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-twitter${iconsStyle}`}
                  ></i>
                </a>
              )}
              {social?.tiktok && (
                <a
                  target="_blank"
                  aria-label="Lea mas en la red social tiktok"
                  href={social?.tiktok}
                  className={social?.tiktok ? 'd-inline' : 'd-none'}
                >
                  <i
                    style={{ color: fontColor }}
                    className={`icon-tiktok${iconsStyle}`}
                  ></i>
                </a>
              )}
            </div>
            <h5
              className="mt-lg-5 mb-lg-3"
              style={{ color: fontColor || '#fff' }}
            >
              Whatsapp
            </h5>
            <a
              className="btn btn-white border btn-investor mb-2 d-block d-lg-inline-block"
              target={'_blank'}
            >
              ENVIAR WHATSAPP
              <i className={'icon-whatsapp' + iconsStyle}></i>
            </a>
            <h5
              className={
                'mb-lg-4' +
                (INVESTOR_CONFIGURATION?.module || OWNER_CONFIGURATION?.module
                  ? 'd-block d-lg-none'
                  : ' d-none')
              }
              style={{ color: fontColor || '#fff' }}
            >
              Accesos privados
            </h5>
            {INVESTOR_CONFIGURATION?.module && (
              <div className="d-block">
                <a
                  className="btn text-white btn-investor mb-2 d-block d-lg-inline-block"
                  target={'_blank'}
                  href={INVESTOR_CONFIGURATION.url_login}
                >
                  {INVESTOR_CONFIGURATION.text_cta || 'INVERSORES'}
                  <i className={'icon-investment' + iconsStyle}></i>
                </a>
              </div>
            )}
            {OWNER_CONFIGURATION?.module && (
              <div className="d-block">
                <a
                  className="btn text-white btn-investor mb-2 d-block d-lg-inline-block"
                  target={'_blank'}
                  href={OWNER_CONFIGURATION.url_login}
                >
                  {OWNER_CONFIGURATION.text_cta || 'PROPIETARIOS'}
                  <i className={'icon-investor-access' + iconsStyle}></i>
                </a>
              </div>
            )}
          </div>
        </div>
      </div>
      <Navbar className="navbar-sticky py-0">
        <Container
          fluid
          className="mx-lg-3"
          style={{ maxWidth: '100%', height: '100%' }}
        >
          <Row className="w-100 d-xl-flex d-none align-items-center justify-content-center  slide-in-up">
            <Col
              lg={4}
              className="d-flex links-column-left"
            >
              <Nav className="nav-menu d-flex justify-content-end w-100">
                {itemsNav.slice(0, Math.ceil(itemsNav.length / 2)).map(({ path, title }, index) => (
                  <Fragment key={index}>
                    <Nav.Item className={'slide-in-up ms-5 ps-4'}>
                      {path.includes('venta') ||
                      path.includes('alquiler') ||
                      (path.includes('temporario') && !location.pathname.includes(path)) ? (
                        <a
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          href={path}
                        >
                          {title}
                        </a>
                      ) : (
                        <Link
                          onClick={() => {
                            scrollTo(0, 0)
                            path.includes('contacto')
                              ? dispatch(updateHeader11({ open: true, view: 0 }))
                              : null
                          }}
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          to={path.includes('contacto') ? '#' : path}
                        >
                          {title}
                        </Link>
                      )}
                    </Nav.Item>
                  </Fragment>
                ))}
              </Nav>
            </Col>
            <Col
              lg={3}
              className="d-flex justify-content-center align-items-center px-xl-5"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-flex align-items-center m-0"
                to="/"
              >
                <img
                  alt="logo-header"
                  src={logo}
                  height={
                    logoSize && height?.desktop
                      ? screen.width < 992
                        ? (parseInt(height?.mobile) * parseInt(logoSize)) / 100 + 'px'
                        : (parseInt(height?.desktop) * parseInt(logoSize)) / 100 + 'px'
                      : '45px'
                  }
                  width={'auto'}
                  className="d-lg-inline-block d-none align-top logo-header slide-in-up"
                />
              </Link>
            </Col>
            <Col
              lg={4}
              className="d-flex links-column-right"
              style={{ alignSelf: 'center', justifyContent: 'flex-start' }}
            >
              <Nav className="nav-menu d-flex justify-content-start w-100">
                {itemsNav.slice(Math.ceil(itemsNav.length / 2)).map(({ path, title }, index) => (
                  <Fragment key={index}>
                    <Nav.Item className="me-5 pe-4 slide-in-up">
                      {path.includes('venta') ||
                      path.includes('alquiler') ||
                      (path.includes('temporario') && !location.pathname.includes(path)) ? (
                        <a
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          href={path}
                        >
                          {title}
                        </a>
                      ) : (
                        <Link
                          onClick={() => {
                            scrollTo(0, 0)
                            path.includes('contacto')
                              ? dispatch(updateHeader11({ open: true, view: 0 }))
                              : null
                          }}
                          style={{ color: fontColor || '#fff' }}
                          className={
                            (location.pathname.includes(path) &&
                              location.pathname !== '' &&
                              path !== '/') ||
                            (path === '/' && location.pathname === '/')
                              ? 'custom-link active text-nowrap'
                              : 'custom-link text-nowrap'
                          }
                          to={path.includes('contacto') ? '#' : path}
                        >
                          {title}
                        </Link>
                      )}
                    </Nav.Item>
                  </Fragment>
                ))}
              </Nav>
            </Col>
          </Row>
          <Row className="w-100 h-100 d-flex justify-content-center align-items-center d-xl-none d-block">
            <Col
              xs={2}
              className="d-flex justify-content-center align-items-center order-lg-1 order-2"
            >
              <button
                aria-label="toggle"
                className="toggle-nav d-xl-none"
                onClick={handleMenuToggle}
              >
                <div className="d-flex align-items-center">
                  <span>
                    {menuOpen ? (
                      <span
                        className="icon-close-light close-icon"
                        style={{ color: fontColor }}
                      />
                    ) : (
                      <>
                        {' '}
                        <i style={{ backgroundColor: fontColor }}></i>
                        <i style={{ backgroundColor: fontColor }}></i>
                        <i style={{ backgroundColor: fontColor }}></i>
                      </>
                    )}
                  </span>
                </div>
              </button>
            </Col>
            <Col
              xs={10}
              className="px-0 h-100 d-flex justify-content-lg-end align-items-center order-lg-2 order-1"
            >
              <Link
                aria-label="Enlace inicio"
                className="d-xl-block d-flex align-items-lg-end m-lg-0"
                to="/"
              >
                <img
                  alt="logo-header-mobile"
                  src={logoMobile}
                  style={{
                    maxHeight: '45px',
                    maxWidth: '100%',
                  }}
                  className="d-xl-none d-block align-top pe-lg-3 ps-3 ps-lg-0"
                />
              </Link>
            </Col>
          </Row>
        </Container>
      </Navbar>
      {menuOpen && (
        <div
          className={`mobile-menu open`}
          style={{ background: hexToRgba(spanText || '#fff', '100') }}
        >
          <Nav className="d-flex flex-column nav-item show">
            {makeItemsNav(allSummaryData, allBlogData, pages, allJobsData)
              .filter((page) => !page.path.includes('detalle') && !page.path.includes('favoritos'))
              .map(({ path, title }, index) => (
                <Fragment key={index}>
                  <Nav.Item className="my-3 ms-5">
                    {path.includes('venta') ||
                    path.includes('alquiler') ||
                    (path.includes('temporario') && !location.pathname.includes(path)) ? (
                      <a
                        className={
                          (location.pathname.includes(path) &&
                            location.pathname !== '' &&
                            path !== '/') ||
                          (path === '/' && location.pathname === '/')
                            ? 'custom-link active'
                            : 'custom-link'
                        }
                        href={path}
                        onClick={() => setMenuOpen(false)}
                      >
                        {title}
                      </a>
                    ) : (
                      <Link
                        onClick={() => {
                          scrollTo(0, 0)
                          setMenuOpen(false)
                          path.includes('contacto')
                            ? dispatch(updateHeader11({ open: true, view: 0 }))
                            : null
                        }}
                        className={
                          (location.pathname.includes(path) &&
                            location.pathname !== '' &&
                            path !== '/') ||
                          (path === '/' && location.pathname === '/')
                            ? 'custom-link active'
                            : 'custom-link'
                        }
                        to={path.includes('contacto') ? '#' : path}
                      >
                        {title}
                      </Link>
                    )}
                  </Nav.Item>
                </Fragment>
              ))}
          </Nav>
        </div>
      )}
    </header>
  ) : (
    ''
  )
}

export default Header11
